/**
 * 直播间跳转链接
 * @param data
 * @param true_name
 * @returns {string}
 */
export function roomUrl(data,true_name) {
  let params = "user_id=" + data.user_id+ "&roomid=" + data.roomid
    + "&role=" + data.role + "&roomtype=" + data.roomtype+"&roomname=" + data.roomname + "&exhticket_num="
    +data.exhticket_num+ "&truename=" + true_name + "&anchorid=" + data.anchorid;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  return "livestudio.html?"+encodeData
}


/**
 * 购票跳转链接
 * @param type
 * @param exhibition_id
 * @returns {string}
 */
export function tickUrl(type,exhibition_id) {
  let params = "type=" + type + "&exhibition_id=" + exhibition_id;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  return "tickets.html?"+encodeData;
}

/**
 * 视频跳转链接加密
 * @param data
 * @returns {string}
 */
export function videoUrl(data) {
  let params = "roomid=" + data.roomid + "&broadcastPlaybackId=" + data.broadcast_playback_id;
  let encodeData = window.btoa(window.encodeURIComponent(params));
  return "playbackVideo.html?"+encodeData;
}

export function windowsGoTo() {
  const https = "https://";
  let protocol = window.location.protocol;
  if (protocol != https) {
    protocol = https;
  }
  const url = protocol + window.location.host +"/"
  return url
}

